import { Container } from "../../elements/Container";
import {
  wrapperRecipe,
  headlineRecipe,
  headline2Recipe,
  counterWrapperRecipe,
  imageWrapperRecipe,
} from "./Banner.style";
import { useThemePattern } from "./utils/useThemePattern";
import { Image } from "../../elements/Image";
import Countdown, { CountdownRenderProps } from "react-countdown";

export interface BannerProps {
  title: string;
  description: string;
  dateToEndCampaign: string;
  optionalImage: { url: string; title?: string };
  themePattern: string;
  daysLabel: string;
  hoursLabel: string;
  minutesLabel: string;
  secondsLabel: string;
}

export const Banner = (props: BannerProps) => {
  const {
    title,
    description,
    dateToEndCampaign,
    optionalImage,
    themePattern,
    daysLabel,
    hoursLabel,
    minutesLabel,
    secondsLabel,
  } = props;
  const themeVariant = useThemePattern(themePattern);

  const counter = ({ formatted: { days, hours, minutes, seconds } }: CountdownRenderProps) => {
    return (
      <div className={counterWrapperRecipe({ theme: themeVariant })}>
        <div>
          {days}
          <p>{daysLabel}</p>
        </div>
        <div>
          {hours}
          <p>{hoursLabel}</p>
        </div>
        <div>
          {minutes}
          <p>{minutesLabel}</p>
        </div>
        <div>
          {seconds}
          <p>{secondsLabel}</p>
        </div>
      </div>
    );
  };

  return (
    <section className={wrapperRecipe({ theme: themeVariant })}>
      <Container noPaddingMobile noPaddingDesktop>
        <span className={headlineRecipe()}>{title}&nbsp;</span>
        <span className={headline2Recipe()}>{description}</span>
        {dateToEndCampaign && <Countdown date={`${dateToEndCampaign}:00+02:00`} renderer={counter} />}
        {optionalImage && (
          <div className={imageWrapperRecipe()}>
            <Image image={{ url: optionalImage.url, title: optionalImage.title }} />
          </div>
        )}
      </Container>
    </section>
  );
};
